.title {
  font-weight: 500;
  font-size: 0.875rem;
  text-transform: uppercase;
}
